// extracted by mini-css-extract-plugin
export var avatarWrapper = "user-avatar-widget-module--avatar-wrapper---cZli";
export var black = "user-avatar-widget-module--black--zE078";
export var editable = "user-avatar-widget-module--editable--QxZO7";
export var fileInput = "user-avatar-widget-module--file-input--ElWxA";
export var hidden = "user-avatar-widget-module--hidden--c1afm";
export var icon = "user-avatar-widget-module--icon--I6MZt";
export var text = "user-avatar-widget-module--text--Oo0h2";